import React from 'react';
import PropTypes from 'prop-types';
import ComplianceReportingBanner from './ComplianceReportingBanner.tsx';

export default function ComplianceReportingBannerComp({ marketingSiteLink }) {
  return <ComplianceReportingBanner marketingSiteLink={marketingSiteLink} />;
}

ComplianceReportingBannerComp.propTypes = {
  marketingSiteLink: PropTypes.string.isRequired
};
